import { P, useScopedSelector } from 'ia-react-core';
import { UserAccountContext, Section } from 'omni-package-react-core';
import React, { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthenticationFactor } from '../../interfaces/AuthenticationFactor';
import { AuthenticationFactors as IAuthenticationFactors } from '../../interfaces/AuthenticationFactors';
import { AuthenticationFactorsResourceInfo } from '../AuthenticationFactorsResource/AuthenticationFactorsResource';
import UpdateFactorsButton from './UpdateFactorsButton';
import ResetAuthenticationFactorsButton from './ResetAuthenticationFactorsButton';

export interface AuthenticationFactorsProps {
  sectionTitle?: string;
  readOnly?: boolean;
}

const AuthenticationFactors: FC<AuthenticationFactorsProps> = ({ sectionTitle, readOnly = false }) => {
  const { t } = useTranslation('AuthenticationFactors');
  const { isProspect, isClient } = useContext(UserAccountContext);
  const isProspectOrClient = isProspect || isClient;

  const currentLanguage = useTranslation().i18n?.language?.substring(0, 2)?.toLocaleLowerCase();
  const colon = currentLanguage === 'fr' ? ' :' : ':';
  const authenticationFactors: IAuthenticationFactors = useScopedSelector(AuthenticationFactorsResourceInfo.dataDst);
  const factors: AuthenticationFactor[] = authenticationFactors?.data || [];
  const behaviours = authenticationFactors?.behaviours;
  const hasFactors = factors.length > 0;

  const toolTip = (!isProspectOrClient && hasFactors) ? behaviours?.introductionText : null;

  return (
    <section data-testid="authentication-factors-4">
      <Section data-testid="authentication-factors-title" name={sectionTitle || t('sectionTitle')} helpText={toolTip}>
        {!hasFactors && <P data-testid="authentication-factors-empty">{t('noData')}</P>}
        {factors.map((x) => <P key={x.type} data-testid="authentication-factors-value">{x.typeLabel}{colon} {x.information}</P>)}
      </Section>
      {!readOnly && hasFactors && !isProspectOrClient && <ResetAuthenticationFactorsButton />}
      {!readOnly && hasFactors && isProspectOrClient && <UpdateFactorsButton />}
    </section>
  );
};

export default AuthenticationFactors;
